import { codeMasterType } from '../../config/constants';
import modelBase from '../../models/model-base.model';
import codeMasterModel from '../common/code-master.model';
import modelBaseV2 from '../model-base-v2.model';

var udfManagementModel = {
  getFieldTypeList: function (successCallBack, failureCallBack) {
    var path = '/api/codemaster/UDFFieldType';
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getMasterList: function (successCallBack, failureCallBack, request) {
    var path = '/api/udf/' + request.udfType + '/masterlist?attributeName=' + request.attributeName + '&attributeType=' + request.attributeType + '&PageIndex=' + request.pageIndex + '&PageSize=' + request.pageSize;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getDetailList: function (successCallBack, failureCallBack, id) {
    var path = '/api/udf/datalist/nopaging?udfMasterId=' + id;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  submitUDFUserData: (successCallBack, failureCallBack, request) => {
    var params = {};
    params.attributeName = request.attributeName;
    params.attributeType = request.attributeType;
    params.description = request.description;
    params.listData = request.dtValues;
    params.data = request.dataValue;
    params.id = request.udfId.toString();
    params.active = request.active;
    params.udfType = "001";

    modelBase.post(successCallBack, failureCallBack, '/api/udf', { body: params });
  },
  getByType: function (successCallBack, failureCallBack, param) {
    var path = `/api/udf/${param.udfType}/${param.countryCode}`;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getMapData: function (successCallBack, failureCallBack, param) {
    var path = `/api/udf/mapdata/${param.udfType}/${param.countryCode}/${param.mapData}`;
    modelBase.get(successCallBack, failureCallBack, path);
  },
  getModelUDFType: function () {
    return codeMasterModel.getByCategoryV2({ category: codeMasterType.modelUDFType });
  },
  getModelUdf: function (encryptedUdfId) {
    let params = { encryptedUdfId }
    return modelBaseV2.get('/api/model/udf/details', { params });
  },
  deleteModelUdf: function (body) {
    return modelBaseV2.post('/api/model/udf/delete', { body });
  },
  addModelUdf: function (body) {
    return modelBaseV2.post('/api/model/udf', { body });
  },
  updateModelUdf: function (body) {
    return modelBaseV2.post('/api/model/udf/update', { body });
  },
  searchModelUdf: function (params) {
    return modelBaseV2.get('/api/model/udf', { params });
  }
}

export default udfManagementModel;
